/**
 * ValueObject class
 */
import { CoreError } from '@goodt-wcore/errors';

class ValueObject {
    /**
     * Default meta factory
     *
     * @static
     * @return {import('./ValueObject').ValueObjectMeta}
     */
    static defaultMeta = () => ({ global: true });

    /**
     * Returns 'value' property if 'obj' is instanceof ValueObject; otherwise just returns the obj itself
     *
     * @static
     * @param {any} valueObject
     * @return {any}
     */
    static getValue = (valueObject) => (valueObject instanceof ValueObject ? valueObject.value : valueObject);

    /**
     *
     */
    value;

    /**
     *
     */
    meta = ValueObject.defaultMeta();

    /**
     * Constructor
     *
     * @template T
     * @param {T} value
     * @param {?ValueObjectMeta} [meta=null]
     * @constructs {ValueObject}
     * @return {ValueObject}
     */
    constructor(value, meta = null) {
        this._validateMeta(meta);

        /**
         * @member {T} value
         */
        this.value = value;

        /**
         * @member {import('./ValueObject').ValueObjectMeta} meta
         */
        this.meta = { ...this.meta, ...meta };
    }

    /**
     * @private
     */
    _validateMeta(meta) {
        if (typeof meta !== 'object') {
            throw new CoreError(`Invalid type of 'meta'`);
        }
    }
}

/**
 * ValueObject factory method
 *
 * @template T
 * @param {T} value
 * @param {?ValueObjectMeta} [meta=null]
 * @return {ValueObject}
 */
const createValueObject = (value, meta = null) => new ValueObject(value, meta);

export { ValueObject, createValueObject };
